<template>
  <div id="app" rel="app">
    <header-main/>
    <router-view @changeSpinner="changeSpinner" />
    <footer-main/>
    <!-- Spinner -->
    <div v-show="spiner" class="spinerAlta" id="spinerDiv">
      <img alt="spinner" class="spiner img-fluid" src="./assets/img/loader.gif"/>
    </div>
  <!-- Fin Spinner -->
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      spiner:false
    }
  },
  methods:{
    changeSpinner(val){
      this.spiner=val
    }
  }
}

</script>

<style>
@import url(https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600);
@import url(https://fonts.googleapis.com/css?family=Roboto+Slab:400,700);
@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
</style>



// WEBPACK FOOTER //
// src/App.vue